// extracted by mini-css-extract-plugin
module.exports = {"dehaat_feed_content":"DehaatFeed_dehaat_feed_content__j1kMS"};